import { fetchJSONWithTimeout } from '@noths/polaris-client-utils';
import getConfig from 'next/config';

import type { NextConfig } from 'src/types/nextConfig';
import { graphqlUnifiedProductQuery } from './queries/query';
import type { UnifiedProduct } from './types/UnifiedProduct';

const { publicRuntimeConfig } = getConfig() as NextConfig;
const UNIFIED_PRODUCT_SERVICE_ENDPOINT = publicRuntimeConfig.endpoints.unifiedProductService;
const CLIENT_TIMEOUT = 1000;

export const fetchUnifiedProduct = async (productUri: string): Promise<UnifiedProduct | null> => {
  const response = await fetchJSONWithTimeout(UNIFIED_PRODUCT_SERVICE_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: {
      query: graphqlUnifiedProductQuery,
      variables: { productUri: `https://notonthehighstreet.com${productUri}` },
    },
    timeout: CLIENT_TIMEOUT,
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch product with URI ${productUri}: ${response.statusText}`);
  }

  const body = await response.json();

  return body.data.product as UnifiedProduct;
};
